import { gql } from '@apollo/client';

const TASK_LIST_TEMPLATE_CREATE_FROM_TASK_LIST = gql`
  mutation TaskListTemplateCreateFromTaskList(
    $input: TaskListTemplateCreateFromTaskListInput!
  ) {
    taskListTemplateCreateFromTaskList(input: $input) {
      errors {
        message
        error
      }
      taskListTemplate {
        __typename
        id
        description
      }
    }
  }
`;

export default TASK_LIST_TEMPLATE_CREATE_FROM_TASK_LIST;
